export const STATS_LEADERS_TAB_NAME = 'leaders';